<ng-container *transloco="let t; prefix: scope">
  <div class="grid grid-cols-5 gap-2">
    <div>
      <p>{{ t('contact') }}</p>
      <input type="text" class="w-64" pInputText [(ngModel)]="contactModel.label" maxlength="100" />
    </div>
    <div>
      <p>{{ t('phone') }}</p>
      <input type="text" class="w-64" pInputText [(ngModel)]="contactModel.phone" maxlength="50" />
    </div>
    <div>
      <p>{{ t('email') }}</p>
      <input type="text" class="w-64" pInputText [(ngModel)]="contactModel.email" maxlength="50" />
    </div>
    <div>
      <p>{{ t('comments') }}</p>
      <input type="text" class="w-64" pInputText [(ngModel)]="contactModel.comment" maxlength="50" />
    </div>
    <div class="self-end">
      <bl-frontend-button
        class="!mr-3"
        variant="secondary"
        (click)="unSelect()"
        [text]="'shared.reset' | transloco"></bl-frontend-button>
      <bl-frontend-button
        (click)="saveContact()"
        [disabled]="client.archived || client.id === -1 || !isContactFormValid"
        [text]="'shared.save' | transloco">
      </bl-frontend-button>
    </div>
  </div>
  <br />
  <br />
  <app-table
    [columns]="columns$ | async"
    [data]="client.contacts"
    sortField="label"
    [columnSelector]="false"
    (rowClick)="onRowSelect($event)"
    rowClass="cursor-pointer"
    [paginator]="false"
    [useFixedStyle]="true">
    <ng-template tableTemplate="bodyCell" tableBodyCellField="action" let-rowData="rowData">
      <span
        (click)="deleteContact(rowData.id)"
        class="far fa-trash-alt cursor-pointer"
        style="text-align: center"
        [title]="t('deleteContact')">
      </span>
    </ng-template>

    <ng-template tableTemplate="emptyMessage">{{ t('noContactsToShow') }}</ng-template>
  </app-table>
</ng-container>
